// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps, Theme } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/discover-starburst.svg';
import { sxAppend } from '../sx';

const styleDiscoverStarburst = {
    color: (theme: Theme) =>
        theme.palette.mode === 'dark'
            ? theme.palette.common.white
            : theme.palette.text.sub,
};

export const DiscoverStarburst = ({ sx, ...props }: SvgIconProps) => (
    <SvgIcon
        component={Svg}
        inheritViewBox
        {...props}
        sx={sxAppend(styleDiscoverStarburst, sx)}
    />
);
